export default __webpack_public_path__ + "static/media/tune.69cbc4f4.svg";